// Pill de status com cor semântica + label — usado em Leads, LeadDetail e Propostas
const STYLES: Record<string, string> = {
  novo: 'bg-zinc-100 text-zinc-600',
  em_contato: 'bg-amber-50 text-amber-700',
  proposta_enviada: 'bg-sky-50 text-[#0369a1]',
  em_negociacao: 'bg-indigo-50 text-indigo-700',
  fechado_ganho: 'bg-emerald-50 text-emerald-700',
  fechado_perdido: 'bg-rose-50 text-rose-700',
  descartado: 'bg-zinc-100 text-[#52525b]',
  draft: 'bg-zinc-100 text-zinc-600',
};

const LABELS: Record<string, string> = {
  novo: 'Novo', em_contato: 'Em contato', proposta_enviada: 'Proposta enviada',
  em_negociacao: 'Em negociação', fechado_ganho: 'Ganho', fechado_perdido: 'Perdido',
  descartado: 'Descartado', draft: 'Rascunho',
};

export default function StatusPill({ status }: { status: string }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STYLES[status] ?? 'bg-zinc-100 text-[#52525b]'}`}>
      <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-current opacity-60" />
      {LABELS[status] ?? status}
    </span>
  );
}
